import { createToken } from '@react-apps/core';
import type { TotvsRepositoryImpl } from '../data/repositories/totvs.repository.impl';

export const TotvsRepositoryToken =
  createToken<TotvsRepositoryImpl>('TotvsRepository');
